import React, { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';
import SingleCardTemplate from '@/components/layouts/SingleCardTemplate';
import Button from '@/components/ui/buttons/Button';
import useCurrentUser from '@/hooks/store/useCurrentUser';

import styles from './AcceptCompletePage.module.scss';

export type AcceptCompletePageProps = {
  complete: boolean;
};

const AcceptCompletePage: React.FC<AcceptCompletePageProps> = ({
  complete,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [, setCurrentUser] = useCurrentUser();
  const [completeState, _] = useState(complete);

  const handleNavigateToMyPage = () => {
    queryClient.removeQueries({ queryKey: ['me'] });
    setCurrentUser(null);
    navigate('/mypage/profile');
  };

  // 引数のcompleteをuseStateで一旦受け取っている理由と、location.stateで直リンク制御をしていない理由は↓です。
  // https://github.com/quipper/school-comm-issues/issues/7167#issuecomment-4417052711
  if (!completeState) return <ErrorPage type="not_found" />;

  return (
    <SingleCardTemplate title="生徒登録完了">
      <div className={styles.AcceptCompletePage__Body}>
        <div className={styles.AcceptCompletePage__Body__Content}>
          <div className={styles.AcceptCompletePage__Body__Content__Title}>
            生徒の登録が完了しました
          </div>
          <div>「マイページ」より詳細をご確認ください。</div>
          <Button
            className={styles.AcceptCompletePage__Body__Content__MyPageButton}
            color="primary"
            type="button"
            onClick={handleNavigateToMyPage}
          >
            マイページへ
          </Button>
        </div>
      </div>
    </SingleCardTemplate>
  );
};

export default AcceptCompletePage;
